/**
 * @description Идентификатор состояния количества активных задач.
 * @type {string}
 */
export const ACTIVE_TASK_COUNT = 'ACTIVE_TASK_COUNT';

/**
 * @description Удалить фильтр
 * @type {string}
 */
export const DELETE_TASK_FILTER = 'DELETE_FILTER';

/**
 * @description Сохранить фильтр
 * @type {string}
 */
export const STORE_TASK_FILTER = 'STORE_TASK_FILTER';

/**
 * @description Ключ хранилища фильтров
 * @type {string}
 */
export const FILTER_STORE_KEY = 'TASK_FILTER_STORE_KEY';
